<mat-card class="cylinder-banner">
  <div class="banner-content">
      <p class="banner-text-color">
        <b>{{recomendation}}</b>{{bannerText}}
        <a href="https://play.google.com/store/apps/details?id=com.payvalida.wallet" target="_blank" rel="noopener noreferrer">{{playStore}}</a>
        {{or}}
        <a href="https://apps.apple.com/us/app/payvalida/id1616898620" target="_blank" rel="noopener noreferrer">{{appStore}}</a>
      </p>
  </div>
</mat-card>
